import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Input, Select, Button } from 'antd'
import {withTranslation} from 'react-i18next'
@inject('marketingSmsManagementStore')
@observer
class FormModal extends Component {
  state = {
    varList: []
  }

  formRef = React.createRef()

  componentDidMount() {
    const {marketingSmsManagementStore} = this.props
    const {templateParams} = marketingSmsManagementStore
    const { template } = this.props
    // 正则表达式匹配包含 {% 和 %} 的完整变量
    const regex = /\{%.*?%}/g;
    const variables = template.match(regex);
    this.setState({
      varList: variables
    })
    templateParams.map(a=> {
      return this.formRef.current.setFieldsValue({
        [`${a?.key}`]: a?.value,
      })
    })
  }

  handleOk = () => {
    const {marketingSmsManagementStore, handleCancel} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      const arr = Object.entries(fieldsValue).filter(([key, value]) => !key.includes("title")).map(([key, value]) => ({ key, value })).sort(function (a, b) {
        return a.key -b.key
      }) || []
      marketingSmsManagementStore.onChangeTemplateParams(arr)
      handleCancel()
    }).catch(() => {})
  }

  render() {
    const {marketingSmsManagementStore, addModalVisible, handleCancel, smsType, t } = this.props
    const {phoneTable} = marketingSmsManagementStore
    return (
      <>
        <Modal
          title={t(`marketingManagement.editVar`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row gutter={[10, 10]}>
              {this.state.varList.map((a,i)=> {
                return <Col span={24} key={i}><Row gutter={[10, 10]}><Col span={10} >
                <Form.Item name={`title_${i}`} initialValue={a}>
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={4} style={{textAlign: 'center', paddingTop: 5}}>{`→`}</Col>
              <Col span={10} >
                <Form.Item name={a}>
                  {smsType==='1' ? <Input placeholder={t(`general.pleaseEnter`)} /> : 
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch>
                    {phoneTable?.map((item,ii) => (<Select.Option key={ii} value={item?.title}>{item?.title}</Select.Option>))}
                  </Select>}
                </Form.Item>
              </Col></Row></Col>
              })}
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
